/**
 * Registry identifier normalisation — client-side mirror of
 * `server/src/utils/companyIdentity.ts` (Audit 20 F-205/F-211).
 * Used for dedupe/identity keys; never fabricates an identifier.
 */

const COMPANIES_HOUSE_PREFIXES = new Set(['OC', 'SC', 'NI', 'FC', 'IP', 'SP', 'LP']);

export const canonicalCompanyNumber = (raw?: string | null): string => {
  const value = (raw || '').replace(/\s+/g, '').toUpperCase();
  if (!value) return '';
  if (/^\d{1,8}$/.test(value)) return value.padStart(8, '0');
  const prefixed = /^([A-Z]{2})(\d{1,6})$/.exec(value);
  if (prefixed && COMPANIES_HOUSE_PREFIXES.has(prefixed[1])) {
    return `${prefixed[1]}${prefixed[2].padStart(6, '0')}`;
  }
  return value;
};

/**
 * F-211: dedupe/identity key = registry + canonical number, so a Companies
 * House `SC######` company and an OSCR `SC######` charity never collide.
 */
export const registryIdentityKey = (
  registryType: string | undefined,
  registrationNumber: string | undefined
): string => `${registryType || 'unknown'}:${canonicalCompanyNumber(registrationNumber)}`;
